import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Tooltip } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';

const ItemPriceChange = () => {
    const { id } = useParams();
    const [categoryId, setCategoryId] = useState('');
    const [itemId, setItemId] = useState('');
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [updatedData, setUpdatedData] = useState({});
    const [previousRates, setPreviousRates] = useState({});
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchCategories();
    }, [isAuthenticated, companyId, token, logout]);

    const fetchCategories = async () => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(cat => ({
                    value: cat.id,
                    label: cat.name
                }));
                setCategoryOptions(options);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const handleCategoryChange = async (event) => {
        const selectedCategoryId = event.target.value;
        setCategoryId(selectedCategoryId);
        fetchItems(selectedCategoryId);
    };

    const fetchItems = async (categoryId) => {
        setIsLoading(true);
        try {
            const response = await fetchData('ItemApi', `/${companyId}/${categoryId}`, token);
            if (response.responseCode === '1111') {
                setItems(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        } finally {
            setIsLoading(false);
        }
    };



    const [updatedItems, setUpdatedItems] = useState([]);

    const handleRateChange = (index, field, value) => {
        const newItems = [...items];
        const item = newItems[index];

        // Check if there's already a previous value stored; if not, store the current value as the previous value
        if (!previousRates[item.id] || !previousRates[item.id][field]) {
            setPreviousRates(prevRates => ({
                ...prevRates,
                [item.id]: {
                    ...prevRates[item.id],
                    [field]: item[field] // Store current value as previous
                }
            }));
        }

        // Update the item's rate with the new value
        item[field] = value;
        setItems(newItems);

        // Update the specific item in the updatedItems array
        const existingItemIndex = updatedItems.findIndex(updatedItem => updatedItem.id === item.id);

        if (existingItemIndex > -1) {
            const newUpdatedItems = [...updatedItems];
            newUpdatedItems[existingItemIndex] = item;
            setUpdatedItems(newUpdatedItems);
        } else {
            setUpdatedItems([...updatedItems, item]);
        }
    };

    const handleUpdateRates = async () => {
        if (updatedItems.length === 0) {
            console.error('No item details selected or missing IDs.');
            return;
        }

        try {
            const promises = updatedItems.map(async item => {
                const response = await updateData('ItemRateCheckingApi', `${item.id}`, item, token);

                if (response.ok) {
                    console.log(`Rates updated successfully for item ID: ${item.id}`);
                } else {
                    const errorData = await response.json();
                    console.error(`Error updating rates for item ID: ${item.id}:`, errorData.message || 'Unknown error');
                }
            });

            await Promise.all(promises);

            alert('Rates updated successfully');
            setUpdatedItems([]);
            fetchItems(categoryId);
            // Once the update is complete, refresh the page
            window.location.reload();
        } catch (error) {
            console.error('Error updating rates:', error.message || 'Unknown error');
        }
    };
    const hasCreateMasterPermission = permissions.includes('Create Master');

    return (


        <div className="w-full max-w-sm container mt-6" style={{ maxWidth: '90%' }}>
            <div className='w-full mb-1 flex' style={{ marginTop: '-10px', marginLeft: '10px' }}>
                <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    ITEM PRICE CHANGE</h6>
            </div>
            <div className="w-full mb-1 flex justify-between items-center" >
                <div className="flex" >
                    <div className="flex flex-col mr-4" style={{ width: '300px', marginLeft: '350px', fontSize: '16px', marginTop: '-40px' }}>
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="category">
                            Variant
                        </label>
                        <Select
                            value={categoryId}
                            onChange={handleCategoryChange}
                            displayEmpty
                            isSearchable
                            style={{ height: '40px' }}
                        >
                            <MenuItem value="" disabled>Select Variant</MenuItem>
                            {categoryOptions.map(category => (
                                <MenuItem key={category.value} value={category.value}>
                                    {category.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </div>

            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-40px' }}>
                <Tooltip title="Exit">
                    <Link to="/Home" style={{ textDecoration: 'none' }}>
                        <Button variant="contained" color="error" style={{ marginLeft: '20px', fontSize: '12px', height: '30px' }}>
                            Back<ExitToAppIcon />
                        </Button>
                    </Link>
                </Tooltip>
                {hasCreateMasterPermission && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            setIsLoading(true);
                            try {
                                await handleUpdateRates();
                            } catch (error) {
                                console.error("Error updating rates:", error);
                            } finally {
                                setIsLoading(false);
                            }
                        }}
                        style={{
                            padding: '6px 20px',
                            border: 'none',
                            borderRadius: '5px',
                            fontSize: '12px',
                            height: '30px',
                            marginLeft: '10px',
                            color: 'white',
                            marginRight: '152px',
                        }}
                        disabled={isLoading}
                    >
                        Update Rates
                    </Button>
                )}
            </div>


            <div className="w-full max-w-sm container mt-6 mx-auto custom-scrollbar" style={{ maxWidth: '100%' }}>
                <style>
                    {`
                    .custom-scrollbar::-webkit-scrollbar {
                        width: 3px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-thumb {
                        background-color: #333;
                        border: 2px solid #555;
                        border-radius: 6px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-track {
                        background-color: #ddd;
                        border-radius: 6px;
                    }
                    `}
                </style>
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto', width: '1200px', marginTop: '20px' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#0B5345', color: 'white' }}>
                                    <TableRow>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}>Variant with Bagweight</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}>Mill Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}></TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}>A1 Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}></TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}>A Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}></TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}>B Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}></TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}>C Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}></TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}>D Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bold', color: 'white' }}></TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody style={{ backgroundColor: 'whitesmoke' }}>
                                    {items.map((item, index) => (
                                        <TableRow key={item.id}>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell sx={{ width: '100px', padding: '2px' }}>
                                                <TextField
                                                    value={item.millRate}
                                                    onChange={(e) => handleRateChange(index, 'millRate', e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {previousRates[item.id]?.millRate || "0.00"}
                                            </TableCell>





                                            <TableCell sx={{ width: '100px', padding: '2px' }}>
                                                <TextField
                                                    value={item.a1price}
                                                    onChange={(e) => handleRateChange(index, 'a1price', e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {previousRates[item.id]?.a1price || "0.00"}
                                            </TableCell>
                                            <TableCell sx={{ width: '100px', padding: '2px' }}>
                                                <TextField
                                                    value={item.aprice}
                                                    onChange={(e) => handleRateChange(index, 'aprice', e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {previousRates[item.id]?.aprice || "0.00"}
                                            </TableCell>
                                            <TableCell sx={{ width: '100px', padding: '2px' }}>
                                                <TextField
                                                    value={item.bprice}
                                                    onChange={(e) => handleRateChange(index, 'bprice', e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {previousRates[item.id]?.bprice || "0.00"}
                                            </TableCell>
                                            <TableCell sx={{ width: '100px', padding: '2px' }}>
                                                <TextField
                                                    value={item.cprice}
                                                    onChange={(e) => handleRateChange(index, 'cprice', e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {previousRates[item.id]?.cprice || "0.00"}
                                            </TableCell>
                                            <TableCell sx={{ width: '100px', padding: '2px' }}>
                                                <TextField
                                                    value={item.dprice}
                                                    onChange={(e) => handleRateChange(index, 'dprice', e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {previousRates[item.id]?.dprice || "0.00"}
                                            </TableCell>
                                            {/* <TableCell>
                                                {previousRates[item.id]?.millRate || "N/A"}
                                            </TableCell> */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                        </TableContainer>
                    </div>
                )}
            </div>
        </div>

    );
};

export default ItemPriceChange;
